import React, { useId } from 'react';

import { cn, Label, OptionAutocomplete } from '@src/components/ui';


/**
 * Base autocomplete field — label above, client-side-filtered combobox, helper/
 * error line below. Same chrome as SelectField but renders `OptionAutocomplete`
 * instead of a native `<Select>`. Receives RHF field props (value/onChange/
 * onBlur/name/ref) plus `error` (bool) and `helperText` from the generic wrapper.
 * Pass `options` as `[{ value, label }]`. Only the props OptionAutocomplete reads
 * are forwarded; RHF's `onBlur`/`name` are intentionally not passed.
 */
const AutocompleteField = React.forwardRef((props, ref) => {
  const {
    label,
    value = '',
    onChange,
    error = false,
    helperText = ' ',
    className,
    options = null,
    placeholder,
    footer,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label
        ? (
          <Label htmlFor={id}>{label}</Label>
        )
        : null}

      <OptionAutocomplete
        ref={ref}
        id={id}
        value={value}
        invalid={error}
        footer={footer}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
      />

      <p className={cn('min-h-4 text-xs', error ? 'text-danger' : 'text-ink-subtle')}>
        {helperText}
      </p>
    </div>
  );
});

AutocompleteField.displayName = 'AutocompleteField';
export default AutocompleteField;
